import { render, staticRenderFns } from "./sales-manager-agent.vue?vue&type=template&id=70828f19&"
import script from "./sales-manager-agent.vue?vue&type=script&lang=js&"
export * from "./sales-manager-agent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports